export const IS_SUBSCRIPTION_ENABLED = process.env.REACT_APP_IS_SUBSCRIPTION_ENABLED === 'true';
export const IS_ORDER_PICKING_ENABLED = process.env.REACT_APP_IS_ORDER_PICKING_ENABLED === 'true';
export const IS_MANDALA_STORES_ENABLED = process.env.REACT_APP_IS_MANDALA_STORES_ENABLED === 'true';
